import { render, staticRenderFns } from "./NewsDetailBody.vue?vue&type=template&id=0bec8460&scoped=true&"
import script from "./NewsDetailBody.vue?vue&type=script&lang=js&"
export * from "./NewsDetailBody.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailBody.vue?vue&type=style&index=0&id=0bec8460&scoped=true&lang=css&"
import style1 from "assets/css/ckeditor.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bec8460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bec8460')) {
      api.createRecord('0bec8460', component.options)
    } else {
      api.reload('0bec8460', component.options)
    }
    module.hot.accept("./NewsDetailBody.vue?vue&type=template&id=0bec8460&scoped=true&", function () {
      api.rerender('0bec8460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/News/NewsDetailBody.vue"
export default component.exports